const technologiesData = require('../Data/technologies.json')
const overridesData = require('../Data/technologyOverrides.json')

const xOffset = 300;
const yOffset = 120;

var nodes = [];
var edges = [];

function AddCategory(blocks, nodeType)
{
    var horizontalIndex = 0;
    var linkData = [];

    blocks.forEach(block => {

        //Add block
        var returnData = AddBlock(block, nodeType, horizontalIndex);

        //Replace horizontal index
        horizontalIndex = returnData.horizontalIndex;

        //Save link data
        linkData.push({ firstTechnologies: returnData.firstTechnologies, lastTechnologies: returnData.lastTechnologies });
    });

    //Link blocks
    for(let i = 1; i < linkData.length; i++)
    {
        var originBlock = linkData[i - 1];
        var destinyBlock = linkData[i];

        //Add edges
        originBlock.lastTechnologies.forEach(originTechnology => {
            destinyBlock.firstTechnologies.forEach(destinyTechnology => {

                //Add edge
                edges.push(FormatEdge(originTechnology, destinyTechnology));
            });
        });
    }
}

function AddBlock(block, nodeType, horizontalIndex)
{
    var maxHorizontalIndex = 0;
    var verticalIndex = 0;
    var firstTechnologies = [];
    var lastTechnologies = [];

    //Each sequence
    block.sequences.forEach(sequence => {

        //Add sequence
        var returnData = AddSequence(sequence, nodeType, horizontalIndex, verticalIndex);

        //Add link data
        firstTechnologies.push(returnData.firstTechnology);
        lastTechnologies.push(returnData.lastTechnology);

        //Max horizontal index
        if(returnData.horizontalIndex > maxHorizontalIndex)
            maxHorizontalIndex = returnData.horizontalIndex;

        //Vertical index
        verticalIndex++;
    });

    return { firstTechnologies: firstTechnologies, lastTechnologies: lastTechnologies, horizontalIndex: maxHorizontalIndex };
}

function AddSequence(sequence, nodeType, horizontalIndex, verticalIndex)
{
    var lastTechnology = "";
    var firstTechnology = "";

    //Each technology
    sequence.technologies.forEach(technology => {

        //Add node
        nodes.push(FormatNode(technology, nodeType, horizontalIndex, verticalIndex));

        //Add edge
        if(lastTechnology != "")
            edges.push(FormatEdge(lastTechnology, technology));

        //First technology
        if(firstTechnology === "")
            firstTechnology = technology;

        //Last technology
        lastTechnology = technology;

        //Increment index
        horizontalIndex++;
    });

    return { firstTechnology: firstTechnology, lastTechnology: lastTechnology, horizontalIndex: horizontalIndex};
}

function FormatNode(technology, nodeType, horizontalIndex, verticalIndex)
{
    return ({
        id: technology,
        position: { x: xOffset * horizontalIndex, y: yOffset * verticalIndex },
        type: nodeType,
        data: { technology: technology }
    })
}

function FormatEdge(origin, target)
{
    return ({
        id: origin + "-" + target,
        source: origin,
        target: target
    })
}

export default function GetCharacterTreeAsFlow(character, nodeType)
{
    nodes = [];
    edges = [];

    //Get technologies
    var override = overridesData.technologyOverrides.find((o) => o.character === character);
    AddCategory(override.blocks, nodeType);

    return ({ nodes: nodes, edges: edges });
}